import { render, staticRenderFns } from "./HomeworkAnswers.vue?vue&type=template&id=361ac6ca"
import script from "./HomeworkAnswers.vue?vue&type=script&lang=js"
export * from "./HomeworkAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports